import React, { useState } from 'react';
import ModalBoxPopup from './ModalBoxPopup';
import Zoomproduct from '../Component/Zoomproduct';

function GridListingData({
  Modal,
  show,
  handleClose,
  Button,
  handlePrev,
  Product,
  currentIndex,
  handleNext
}) {
  const [detailModalShow, setDetailModalShow] = useState(false); // For ModalBoxPopup
  const [zoomModalShow, setZoomModalShow] = useState(false); // For Zoomproduct modal
  const currentImage = Product && Product.length > 0 ? Product[currentIndex] : null;

  // Open detail modal (ModalBoxPopup)
  const handleImageClick = () => {
    setDetailModalShow(true);
  };

  const handleDetailModalClose = () => {
    setDetailModalShow(false);
  };

  // Open Zoomproduct modal
  const handleZoomClick = () => {
    setZoomModalShow(true);
  };

  const handleZoomClose = () => {
    setZoomModalShow(false);
  };

  return (
    <>
      {/* Main Image Viewer Modal */}
      <Modal show={show} onHide={handleClose} fullscreen centered>
        <Modal.Body className="text-center p-0">
          <Button
            variant="light"
            onClick={handleClose}
            className="position-absolute top-0 end-0 close-btns"
            style={{ zIndex: 1050 }}
          >
            <i className="bi bi-x-lg"></i>
          </Button>

          <div className="modal-image-container-BOX d-flex justify-content-center align-items-center">
            <Button
              className="bg-transparent"
              variant="secondary"
              onClick={handlePrev}
              disabled={currentIndex === 0}
            >
              <i className="bi bi-chevron-left"></i>
            </Button>

            <div style={{ position: 'relative' }}>
          
              {currentImage ? ( 
                <>
                  <img
                    src={currentImage}
                    alt="Preview"
                    style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                    onClick={() => {
                      if (window.innerWidth <= 768) {
                        window.location.href = '/mobileGrid';
                      } else {
                        handleImageClick();
                      }
                    }}
                  />

                  {/* Zoom Icon */}
                  <span className="zoomicon" onClick={handleZoomClick} style={{ cursor: 'pointer' }}>
                    <i className="bi bi-zoom-in"></i>
                  </span>
                </>
              ) : (
                <p>No image available</p>
              )}
              
              <h3 className="text-xl text-gray-500 mt-3">
                AFROZ 0001 <span className="text-green-600">234</span>
              </h3>
            </div>

            <Button
              className="bg-transparent"
              variant="secondary"
              onClick={handleNext}
              disabled={currentIndex === Product.length - 1}
             >
              <i className="bi bi-chevron-right"></i>
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Second Detail Modal */}
      <ModalBoxPopup
        Modal={Modal}
        detailModalShow={detailModalShow}
        handleDetailModalClose={handleDetailModalClose}
        Button={Button}
        currentImage={currentImage}
      />

      {/* Zoom Modal - with image */}
      <Zoomproduct
        show={zoomModalShow}
        onHide={handleZoomClose}
        currentImage={currentImage}
      />
    </>
  );
}
export default GridListingData;
